// Temporarily reporting the condition of a missing sku to troubleshoot
// product data. The reporting can be remove once the root cause of the
// missing skus has been identified.
const logOptionsMissingSkus = (selectedOptions) => {
  let loggedMissingSku = false;
  selectedOptions.map((option) => {
    const isMissingSkuPDP = !option.size?.sku;
    const isMissingSkuPreviousFavorites = !option.product?.form?.sizes?.[0].sku;

    if (isMissingSkuPDP && isMissingSkuPreviousFavorites) {
      loggedMissingSku = true;
    }
  });
  return loggedMissingSku;
};

export default logOptionsMissingSkus;
